import { render } from "./TaskHistory.vue?vue&type=template&id=50bed93b&scoped=true"
import script from "./TaskHistory.vue?vue&type=script&lang=js"
export * from "./TaskHistory.vue?vue&type=script&lang=js"

import "./TaskHistory.vue?vue&type=style&index=0&id=50bed93b&scoped=true&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50bed93b"]])

export default __exports__